export default __webpack_public_path__ + "static/media/about-18.d7fab785.jpg";